import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { forkJoin, of } from 'rxjs';
import { first, map, switchMap } from 'rxjs/operators';

import { LandingService } from 'src/app/core/http/apiLanding/landing.service';
import { IUser } from 'src/app/core/interfaces/shared/IUser';
import { SpinnerService } from 'src/app/core/services/spinner/spinner.service';
import { IConsent } from 'src/app/shared/components/consents/consents.component';
import { GlobalDialogComponent } from 'src/app/shared/components/globaldialog/globaldialog.component';
import { HeaderConfiguration } from 'src/app/shared/components/header/header.component';
import { Title } from 'src/app/shared/components/title/title.component';
import { IClientState } from 'src/app/state/client/client.models';
import { setUser } from 'src/app/state/user/user.actions';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {
  data: IClientState = {
    idPersona: 0,
    cotizationId: 0,
    productId: 0,
    productPrice: 0,
    category: '',
    productShort: '',
    model: '',
    brand: '',
    quota: 0,
    purchaseDate: '',
    personalData: {
      name: '',
      surname: '',
      nif: '',
      phone: '',
      email: '',
      address: '',
      postalCode: ''
    },
    coverages: []
  }
  titleData: Title;
  headerConfiguration: HeaderConfiguration = {
    layoutAlign: 'start start',
    sections: [
      {
        partner:true,
        menu:false,
      }
    ],
  };
  hiddenPersonalData: boolean = true;
  contractButtonEnabled: boolean = false;
  consents: IConsent[];
  uuid: any;
  antiguedadProducto: Date;
  showInvoiceAlert: boolean = false;

  proxy_enabled = environment.proxy.enabled;
  partner: string;

  constructor (
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private store: Store,
    private spinnerService: SpinnerService,
    private dialog: MatDialog,
    private httpClient: HttpClient,
    private landingService: LandingService
  ) {}

  ngOnInit(): void {

   let login$ = of({ bearer: "disabled" });
   if(this.proxy_enabled) {
      // ToDo: Pasar a un guardian de la parte publica ya que toda la parte publica debe ir por proxy
     login$ = this.httpClient.get<{ bearer: string }>(`${environment.proxy.root}/${environment.proxy.login}`).pipe(
       first(),
       switchMap(resp => {
         sessionStorage.setItem("TokenProxy", resp.bearer);
         return of(resp);
       })
     );
    }
    
    login$.subscribe(_ => {
     this.setClientData();
   });
  }

  private setClientData(){
    forkJoin([
      this.route.params.subscribe(res=>{
        this.uuid = res.uid
        this.spinnerService.show();
      }),
      this.landingService.getObjetsCotizationPolicy({UIDCotizacion: this.uuid}).pipe(first()).subscribe(res => {
        if (res.succeeded) {
          this.data.cotizationId = res.data[0].idCotizacion
          this.data.productPrice = res.data[0].valor
          let date = new Date(res.data[0].antiguedad)
          let dateOptions: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: '2-digit' };
          this.data.purchaseDate = date.toLocaleString('es-ES', dateOptions);
          this.data.brand = res.data[0].objetoMarcaDescripcion
          this.data.model = res.data[0].objetoModeloDescripcion

          this.antiguedadProducto = new Date(res.data[0].antiguedad)
          this.isActualDate()

          this.landingService.getCotizationList({idCotizacion: this.data.cotizationId}).pipe(first()).subscribe(res => {

            const estado = res.data[0].estado
            const estadoInterno = res.data[0].estadoInterno

            if(!(estado === 'En espera' && estadoInterno === 'Proyecto')){
              this.openPopupLinkExpired()
            }
            
            this.partner = res.data[0].entidad;
            this.data.productId = res.data[0].idProducto;
            this.data.category = res.data[0].categoria
            this.data.productShort = res.data[0].familia
            this.data.quota = res.data[0].primaTotal
            this.data.idPersona = res.data[0].idPersona

            this.setTitleData();

            this.setPartnerInfo(res.data[0].idEntidad, {});

            const coberturas_obligatorias$ = this.landingService.getCoberturasObligatoriasByIdCotizacion(this.data.cotizationId);
            const coberturas_opcionales$ = this.landingService.getCoberturasOpcionales(this.data.cotizationId);

            forkJoin([coberturas_obligatorias$, coberturas_opcionales$]).pipe(
              map(([obligatorias, opcionales]) => {
                obligatorias.forEach(x => x.mandatory = true);
                opcionales.forEach(x => x.mandatory = false);
                return [...obligatorias, ...opcionales];
              })
            ).subscribe(resp => {
              let filteredCoverages = resp.filter(coverage => coverage.seleccionada && coverage.idModalidad !== 86 && coverage.idModalidad !== 81);
              
              filteredCoverages.forEach(activatedCoverages => {
                this.getCoverageInfoText(activatedCoverages.aliasCobertura, res.data[0].idProducto).subscribe(res => {
                  activatedCoverages.details = res
                  this.data.coverages.push(activatedCoverages)
                })
              });
            })

            this.data.personalData = {
              name: res.data[0].nombre,
              surname: [res.data[0].apellido1, res.data[0].apellido2].filter(x => !!x).join(" "),
              nif: res.data[0].numDocumento,
              phone: res.data[0].numTelefono,
              email: res.data[0].email,
              address: res.data[0].nombreVia ? res.data[0].nombreVia+' '+ (res.data[0].numeroCalle ? res.data[0].numeroCalle: '') : undefined,
              postalCode: res.data[0].codigoPostal
            }

          })
        }
      }),
      this.spinnerService.hide()
    ])
    
    
    // this.store.dispatch(setClient({ clientData: this.data }));
  }

  isActualDate() {
    const todayDate = new Date();

    if (this.antiguedadProducto.getFullYear() < todayDate.getFullYear() ||
      (this.antiguedadProducto.getFullYear() === todayDate.getFullYear() &&
        this.antiguedadProducto.getMonth() < todayDate.getMonth())) {
      this.showInvoiceAlert = true;
    } else {
      this.showInvoiceAlert = false;
    }
  }

    // Se crea esta funcion SOLO PARA MOCK, no deberia existir. 
  // ToDo: Cuadrar con funcional que campo habría que usar de la base de datos en vez de este switch
  getAPICoverageAlias(alias: string) {
    switch(alias) {
      case "Robo": return "roboYPerdida";
      case "Daños materiales": return "DetCobDaños";
      default: return alias;
    }
  }

  getCoverageInfoText(alias: string, idProducto: number) {
    const coverage_alias = this.getAPICoverageAlias(alias);
    return this.landingService.getCoverageInfoText(coverage_alias, idProducto)
      .pipe(
        first(),
        switchMap(resp => {
          return of(resp.data.sort((objectA, objectB) => {
            return objectA.nivel - objectB.nivel || objectA.orden - objectB.orden
          }));
        })
      )
  }

  private setTitleData(): void {
    this.titleData = {
      title: '',
      subtitle: this.translateService.instant('landing.headerSubtitle')+' '+this.data.productShort,
      divider: true,
      price: this.data.quota
    };

    this.translateService.get('landing.headerTitle').subscribe( res => {
      this.titleData.title = res
    })
  }

  toggle(){
    this.hiddenPersonalData = !this.hiddenPersonalData;
  }

  getAcceptedConsents($event){
    this.contractButtonEnabled = $event
    .filter(localconsent => localconsent.obligatorio)
    .every(localconsent => localconsent.aceptado);
    if (this.contractButtonEnabled) {
      this.consents = $event
    }
  }

  acceptConsents(){
    let localConsent= {
      idPersona: this.data.idPersona,
      consentimientos: []
    }
    
    this.consents.forEach(element => {
      localConsent.consentimientos.push({idConsentimiento: element.idConsent, aceptar: element.aceptado})
    });
    
    forkJoin([
      this.landingService.acceptCotizationLanding(this.data.cotizationId),
      this.landingService.setConsentimientosLocalJob(localConsent),
      
    ]).pipe(first()).subscribe(res => {
      this.openCompletePopup()
    })
  }

  openCompletePopup(){
    let content = [];
    content.push({descPantallaSeccion: this.translateService.instant('landing.popupText')})

    content[0].descPantallaSeccion = content[0].descPantallaSeccion.replace('[PRODUCT]', this.data?.brand+' '+this.data?.model) 
    content[0].descPantallaSeccion = content[0].descPantallaSeccion.replace('[PARTNER]', this.partner) 
    
    const dialogRef = this.dialog.open(GlobalDialogComponent, {
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      maxHeight: '100vh',
      disableClose: true,
      panelClass: 'clientFinishDialog-panel',
      data: {
        title: this.translateService.instant('landing.popupTitle'),
        content: content,
        info: true,
        closeIcon: false
      },
    });
    
  }

  openPopupLinkExpired(){
    
    const dialogRef = this.dialog.open(GlobalDialogComponent, {
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      maxHeight: '100vh',
      disableClose: true,
      panelClass: 'clientFinishDialog-panel',
      data: {
        title: 'Lo sentimos, este enlace ha caducado.',
        content: '',
        info: true,
        closeIcon: false
      },
    });
    
  }

  setPartnerInfo(idEntidad: number, userData: IUser){
    this.landingService.getPartnerInfo(idEntidad).subscribe(resp=> {
      userData.partner = resp.data;
      userData.partner.idEntidad = idEntidad;
      this.store.dispatch(setUser({ accountInfo: userData }));
    })
  }

}
